import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes([
  'CLIENTS_LIST_RESET',
  'CLIENTS_LIST_PUSH',
  'CLIENTS_LIST_REPLACE',
  'CLIENTS_LIST_REMOVE',
]);
